export default __webpack_public_path__ + "static/media/annex7.d183a049.png";